module.exports = __webpack_public_path__ + "img/PDV-Mini-Agil.fae0604b.jpg";